import React from 'react';

const FancyButton = (props) => {
  return (
    <button>{props.label}</button>
  )
}

export default FancyButton;